import { useLocation } from 'react-router-dom'
import { useCms } from '../context/CmsContext'

export function WhatsAppButton() {
  const { data } = useCms(); const location=useLocation(); const s=data.settings
  if (s['whatsapp.enabled'] !== 'true') return null
  const base=s['whatsapp.message'] || 'Hi WebsMetrix Team, I visited your website and would like to discuss your services.'
  const message=s['whatsapp.includePage']==='true' ? `${base}\nPage: ${window.location.origin}${location.pathname}` : base
  const href=`https://wa.me/${s['whatsapp.number'] || '917696115194'}?text=${encodeURIComponent(message)}`
  return <a className="whatsapp-button" href={href} target="_blank" rel="noreferrer" aria-label="Chat with WebsMetrix on WhatsApp"><span>WhatsApp</span><b>↗</b></a>
}
